"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CapacityModel {
    constructor(cache) {
        this.getCapacityByUserId = async (userId) => (await this.cache.getObject(CapacityModel.DB_NAME).asPromise())[userId];
        this.setCapacityByUserId = async (userId, capacities) => {
            const capacitiesItems = (await this.cache.getObject(CapacityModel.DB_NAME).asPromise());
            capacitiesItems[userId] = capacities;
            await this.cache
                .setObject(CapacityModel.DB_NAME, capacitiesItems)
                .asPromise();
        };
        this.setCapacities = (capacityValues) => this.cache.setObject(CapacityModel.DB_NAME, capacityValues).asPromise();
        this.cache = cache;
    }
}
CapacityModel.DB_NAME = "MOCk.CAPACITY_DB";
exports.default = CapacityModel;
//# sourceMappingURL=CapacityModel.js.map